import { fetcher } from "../fetcher";

type GetContanctDataParams = {
  with?: "settings"[];
};

export const contactService = {
  getMessageTypes: async () => {
    return await fetcher(`/message-types/all`, {
      method: "GET",
      schema: contactMessageTypesSchema,
    });
  },
  storeMessage: async (payload: ContactMessage) => {
    return await fetcher(`/messages`, {
      method: "POST",
      body: payload,
    });
  },
  getContanctData: async (params?: GetContanctDataParams) => {
    return await fetcher(`/setting-categories/all`, {
      method: "GET",
      params,
      // schema: settingsContactDataSchema,
    });
  },
};
